module.exports = __webpack_public_path__ + "img/loading.aee4582d.gif";